import { tv, type VariantProps } from "../../../../util/tv";

const lyricsVariant = tv({
  slots: {
    base: [
      "relative",
      "w-full h-full",
      "pr-2.5",
      "before:absolute before:bottom-0 before:inset-x-0 before:z-10",
      "before:w-full before:h-12",
      "before:bg-gradient-to-t before:from-black before:to-black/0",
      "before:select-none before:pointer-events-none",
    ],
    scrollArea: [
      "w-full h-full",
      "overflow-y-auto",
      "tiny-scrollbar-showcase tiny-scrollbar-showcase--vertical",
      "p-6 pr-2.5",
    ],
    line: ["flex flex-wrap", "[&:not(:last-child)]:mb-1.5"],
  },
});

export type LyricsVariantProps = VariantProps<typeof lyricsVariant>;

export { lyricsVariant };
